module.exports = __webpack_public_path__ + "img/login-recomendations5-exotics.77418fd7.jpg";